import { render, staticRenderFns } from "./ArrowCarouselDown.vue?vue&type=template&id=4fbc64c4&"
import script from "./ArrowCarouselDown.vue?vue&type=script&lang=js&"
export * from "./ArrowCarouselDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports